/**
 * An AbortSignal that fires after `ms` (and when `signal`, if given, does).
 * Uses AbortSignal.timeout/any where available and an AbortController with a
 * timer elsewhere (e.g. Safari before 16), so requests are bounded everywhere
 * and never fail just because the API is missing.
 */
export function deadlineSignal(ms: number, signal?: AbortSignal | null): AbortSignal | undefined {
  if (typeof AbortController === "undefined") return signal ?? undefined;
  if (typeof AbortSignal.timeout === "function" && (!signal || typeof AbortSignal.any === "function")) {
    const deadline = AbortSignal.timeout(ms);
    return signal ? AbortSignal.any([signal, deadline]) : deadline;
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  if (signal) {
    if (signal.aborted) controller.abort();
    else signal.addEventListener("abort", () => controller.abort(), { once: true });
  }
  controller.signal.addEventListener("abort", () => clearTimeout(timer), { once: true });
  return controller.signal;
}
